// These constants are used for requests to the local web server

import { FUNDSSERVICES_SECURITY_BASE_PATH } from 'src/app/constants/NextGenConstants';

export const SECURITY_USER_ENTITLEMENTS_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/entitlements`;
export const SECURITY_POLICIES_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/policies`;
export const SECURITY_LID_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/lid`;
export const SECURITY_SAVE_TERMS_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/saveTerms`;
export const SECURITY_GET_TERMS_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/getTerms`;
